module.exports = __webpack_public_path__ + "assets/block-active.ff6bc9b9.svg";